import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { ImportTypeInfoSection } from '../sections/ImportTypeInfoSection';
import { ScheduleInfoSection } from '../sections/ScheduleInfoSection';

interface ConfigurationDetailsPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type ConfigurationDetailsPanelProps = ConfigurationDetailsPanelLocalProps & ToxnotComponentProperties;

class ConfigurationDetailsPanelComponent extends ToxnotComponent<ConfigurationDetailsPanelProps> {
    render() {
        const { config, appServices } = this.props;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Configuration Details")}</h3>
                </div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-6">
                            <h4>{this.localizeString("Import Details")}</h4>
                            <ImportTypeInfoSection configData={config} />
                        </div>
                        <div className="col-md-6">
                            <h4>{this.localizeString("File Details")}</h4>
                            <p><strong>{this.localizeString("File Name:")}</strong> {config.fileName || 'Not specified'}</p>
                            <p><strong>{this.localizeString("Sub Path:")}</strong> {config.subPath || 'Not specified'}</p>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-6">
                            <h4>{this.localizeString("Scheduling")}</h4>
                            <ScheduleInfoSection configData={config} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const ConfigurationDetailsPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ConfigurationDetailsPanelComponent);
